export enum CategoryId {
    ROOMS = 6,
}
